document.addEventListener('DOMContentLoaded', () => {
  const blogCategories = [
    ['schmuck-und-mode', 'Schmuck und Mode'],
    ['beauty', 'Beauty'],
    ['shoplc-events', 'ShopLC Events'],
    ['edelsteine', 'Edelsteine'],
    ['im-trend', 'Im Trend'],
    ['feiertage', 'Feiertage'],
    ['lifestyle', 'Lifestyle'],
  ];

  const escapeHTML = (value) => {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  };

  const stripHTML = (value) => {
    const div = document.createElement('div');
    div.innerHTML = value || '';
    return div.textContent || div.innerText || '';
  };

  const formatArticleDate = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';

    return date.toISOString().slice(0, 10);
  };

  const handleize = (value) =>
    String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const findArticleCategory = (article) => {
    const tags = Array.isArray(article.tags)
      ? article.tags
      : String(article.tags || '')
          .split(',')
          .map((tag) => tag.trim())
          .filter(Boolean);

    for (const tag of tags) {
      const tagHandle = handleize(tag);
      const match = blogCategories.find(([handle]) => handle === tagHandle);
      if (match) return { handle: match[0], label: match[1] };
    }

    return null;
  };

  const renderBlogSearchArticle = (article) => {
    const title = escapeHTML(article.title);
    const url = article.url || '#';
    const imageUrl = article.featured_image?.url || article.image || '';
    const excerpt = stripHTML(article.body || article.summary || article.excerpt).trim();
    const excerptPreview = excerpt.slice(0, 280);
    const publishedAt = formatArticleDate(article.published_at);
    const category = findArticleCategory(article);
    const blogUrl = document.querySelector('.blog-posts-container')?.dataset.blogUrl || '/blogs/shoplc-blog';

    return `
      <div class="blog-post-item" data-page="search">
        <div class="blog-post-card">
          <a class="blog-post-title" href="${url}">
            <h2>${title}</h2>
          </a>
          <div class="blog-post-body">
            ${
              imageUrl
                ? `<div class="blog-post-card__image-container">
                    <a href="${url}">
                      <img
                        src="${imageUrl}"
                        alt="${title}"
                        loading="lazy"
                        class="border-style blog-post-card__image blog-post-card__image--large"
                      >
                    </a>
                  </div>`
                : ''
            }
            ${
              excerptPreview
                ? `<div class="blog-post-description">
                    <p>${escapeHTML(excerptPreview)}</p>
                    <a href="${url}">Weiterlesen</a>
                  </div>`
                : ''
            }
            <div class="blog-post-information">
              ${publishedAt ? `<p class="blog-post-date">Veröffentlicht ${publishedAt}</p>` : ''}
              ${
                category
                  ? `<p class="blog-post-category">
                      Kategorisiert als
                      <a href="${blogUrl}/tagged/${category.handle}">${escapeHTML(category.label)}</a>
                    </p>`
                  : ''
              }
            </div>
          </div>
        </div>
      </div>
    `;
  };

  const loadBlogSearchResults = async () => {
    const params = new URLSearchParams(window.location.search);
    const query = params.get('q')?.trim();
    const grid = document.querySelector('.blog-posts-container');
    if (!query || !(grid instanceof HTMLElement)) return;

    const blogUrl = grid.dataset.blogUrl || window.location.pathname;
    const requestUrl = new URL('/search/suggest.json', window.location.origin);
    requestUrl.searchParams.set('q', query);
    requestUrl.searchParams.set('resources[type]', 'article');
    requestUrl.searchParams.set('resources[limit]', '10');
    requestUrl.searchParams.set('resources[options][fields]', 'title,body');

    try {
      grid.setAttribute('aria-busy', 'true');
      const response = await fetch(requestUrl.toString());
      if (!response.ok) throw new Error('Blog search request failed');

      const data = await response.json();
      const articles = data?.resources?.results?.articles || [];
      const blogArticles = articles.filter((article) => {
        if (!article.url) return false;
        return new URL(article.url, window.location.origin).pathname.startsWith(blogUrl);
      }).sort((a, b) => {
        const dateA = new Date(a.published_at || 0).getTime();
        const dateB = new Date(b.published_at || 0).getTime();
        return dateB - dateA;
      });

      document.querySelector('.blog-pagination')?.remove();

      grid.innerHTML = blogArticles.length
        ? blogArticles.map(renderBlogSearchArticle).join('')
        : `<p class="blog-search-empty">Entschuldigung, aber nichts entspricht Ihren Suchbegriffen. Bitte versuchen Sie es mit anderen Schlüsselwörtern</p>`;
    } catch (error) {
      console.error(error);
      grid.innerHTML = `<p class="blog-search-empty">Die Suche konnte nicht geladen werden.</p>`;
    } finally {
      document.querySelectorAll('.js-searchPost').forEach((input) => {
        if (!(input instanceof HTMLInputElement)) return;
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
      document.documentElement.classList.remove('blog-search-pending');
      grid.removeAttribute('data-blog-search-loading');
      grid.removeAttribute('aria-busy');
    }
  };

  const searchForms = document.querySelectorAll('.blog__search-form');

  searchForms.forEach((form) => {
    const searchInput = form.querySelector('.js-searchPost');
    const resetButton = form.querySelector('.js-resetButton');
    const searchButton = form.querySelector('.js-searchButton');

    if (!(searchInput instanceof HTMLInputElement)) return;

    const updateSearchControls = () => {
      const hasValue = Boolean(searchInput.value.trim());
      resetButton?.classList.toggle('d-none', !hasValue);
      searchButton?.classList.toggle('d-block', !hasValue);
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const searchValue = searchInput.value.trim();
      if (!searchValue) return;

      const searchUrl = new URL(searchInput.dataset.url || form.action, window.location.origin);
      searchUrl.searchParams.set('q', searchValue);
      searchInput.value = '';
      updateSearchControls();
      window.location.href = searchUrl.toString();
    });

    searchInput.addEventListener('input', updateSearchControls);

    resetButton?.addEventListener('click', () => {
      searchInput.value = '';
      searchInput.focus();
      updateSearchControls();
    });

    updateSearchControls();
  });

  loadBlogSearchResults();

  const openBtn = document.querySelector('.menu-btn-open-js');
  const closeBtn = document.querySelector('.menu-btn-close-js');
  const drawer = document.querySelector('.menu-drawer-js');
  const overlay = document.querySelector('.menu-overlay-js');

  if (!openBtn || !closeBtn || !drawer || !overlay) return;

  const openMenu = () => {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  const closeMenu = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  openBtn.addEventListener('click', openMenu);
  closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMenu();
    }
  });
});
